import React from "react";
import { GLOBALMESSAGES } from "../../constants/messages";
import { Box, Button, Card, ThemeProvider, Typography } from "@mui/material";
import theme from "../../assets/theme/theme";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { GLOBALSETTINGS } from "../../data/constants";
import { isOffline } from "../../utils/userFacingError";

const ErrorFallBackUIRoute = () => {
 // Bug 75680: App.tsx no longer routes network rejections here, but this page is still
 // reachable while the connection is down — it must not contradict the network message.
 const isNetworkDown = isOffline();

 return (
        <ThemeProvider theme={theme}>
          <>
            <div className="error-page p-4">
              <div className="text-center mb-4">
                <img
                  src="/logo-transparent.svg"
                  alt="logo"
                  className="signin-logo"
                />
              </div>
              <Card variant="outlined" className="card p-4 text-center">
                 <Typography variant="h5" className="error-sub-title">
                            {isNetworkDown ? GLOBALMESSAGES.NETWORK_ERROR_TITLE : "Something went wrong:"}
                            </Typography>
                
                            <Typography variant="body1" className="page-error-text">
                            {isNetworkDown ? GLOBALMESSAGES.NETWORK_ERROR : GLOBALMESSAGES.GLOBAL_ERROR}
                            </Typography>
                
                <div className="text-center">
                  <Box sx={{}} className="action-container">
                  <Button onClick={() => window.location.href = GLOBALSETTINGS.DEFAULT_PAGE} variant="contained" startIcon={<HomeRoundedIcon />}>
                  Back to Dashboard
                </Button>
                  </Box>
                </div>
              </Card>
            </div>
          </>
        </ThemeProvider>
      );
    }


export default ErrorFallBackUIRoute;
